// extracted by mini-css-extract-plugin
module.exports = {"title":"PromptText_title__guFVR","message":"PromptText_message__2W3qN"};